<template>
  <svg width="34"
       height="34"
       viewBox="0 0 34 34"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_193_10468)">
      <circle cx="17" cy="18" r="13" fill="url(#paint0_linear_193_10468)" />
    </g>
    <path
      d="M16.9999 21.8333L12.8852 23.9967L13.6712 19.4147L10.3379 16.17L14.9379 15.5033L16.9952 11.3347L19.0526 15.5033L23.6526 16.17L20.3192 19.4147L21.1052 23.9967L16.9999 21.8333Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <defs>
      <filter id="filter0_d_193_10468"
              x="0"
              y="0"
              width="34"
              height="34"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="-1" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.117647 0 0 0 0 0.294118 0 0 0 0 1 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_193_10468" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_193_10468" result="shape" />
      </filter>
      <linearGradient id="paint0_linear_193_10468"
                      x1="26"
                      y1="5"
                      x2="8"
                      y2="31"
                      gradientUnits="userSpaceOnUse">
        <stop stop-color="#FFBE15" />
        <stop offset="1" stop-color="#D19700" />
      </linearGradient>
    </defs>
  </svg>
</template>
